import React, { useState } from "react";
import { useCategories } from "../../../hooks/useCategories";
import axios from "axios";
import SectionTitle from "../../../assets/components/TitleGroup";
import { useFixedLayout } from "../../../hooks/useFixedLayout";
import ListCard from "../../../assets/components/ListCard";
import infoRed from "../../../assets/icons/warning/info_red.svg";
import PlaceholderB from "../../../assets/components/PlaceholderB";
import CategoryBottomSheet from "../../../assets/components/CategoryBottomSheet";
import { SingleButton } from "../../../assets/components/ButtonGroup";

const AdsRegistSelf7 = ({
  setStoreBusinessNumber,
  seed,
  goToStep,
  setStep8Shop,
  targetStep8,
}) => {
  const [storeName] = useState(seed.storeName);
  const [zonecode] = useState(seed.zonecode);
  const [roadName] = useState(seed.roadAddress);
  const [detailAddress] = useState(seed.detailAddress);
  const [loading, setLoading] = useState(false);
  const [businessOwnerName, setBusinessOwnerName] = useState("");
  const [businessNumber, setBusinessNumber] = useState("");
  const [category, setCategory] = useState("");

  const { bottomSpace, footerRef } = useFixedLayout();
  const {
    mainCategory,
    setMainCategory,
    mainCategories,
    subCategory,
    setSubCategory,
    subCategories,
    detailCategory,
    setDetailCategory,
    detailCategories,
  } = useCategories();

  const isSubmitDisabled =
    !businessOwnerName.trim() || !businessNumber.trim() || !category.trim();

  const fullAddress =
    zonecode && roadName ? `(${zonecode}) ${roadName} ${detailAddress}` : "";

  const onSubmit = async () => {
    if (loading || isSubmitDisabled) return;
    setLoading(true);

    try {
      const payload = {
        user_id: Number(localStorage.getItem("user_id")),
        store_name: storeName,
        road_name: roadName,
        business_name: businessOwnerName,
        business_number: businessNumber,
        large_category_code: mainCategory !== "0" ? mainCategory : null,
        medium_category_code: subCategory !== "0" ? subCategory : null,
        small_category_code: detailCategory !== "0" ? detailCategory : null,
        status: "active",
      };

      const res = await axios.post(
        `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/new/store/register`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (res?.data?.success === true) {
        setStoreBusinessNumber(res.data.store_business_number);
        setStep8Shop({
          storeName,
          address: fullAddress,
          businessName: businessOwnerName,
          businessNumber,
          category,
        });
        goToStep(targetStep8);
      } else {
        window.alert("등록에 실패했습니다.");
      }
    } catch (error) {
      console.error("매장 정보 등록 오류:", error);
      window.alert(`매장 정보 등록 중 오류:\n${error?.response?.data?.detail || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const formatBizNumber = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 10);
    if (digits.length < 4) return digits;
    if (digits.length < 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
  };

  return (
    <div className="flex flex-col">
      <div className="flex-1 px-[16px] pt-[16px] flex flex-col" style={{ paddingBottom: bottomSpace }}>
        <SectionTitle
          title="매장 정보 등록"
          subTitle="일치하는 매장 정보가 없어 직접 매장 정보를 등록해 주세요"
          className="pb-[40px]"
        />

        <div className="space-y-[32px] pb-[28px]">
          <ListCard title={storeName} subtitle={fullAddress} />

          <div className="space-y-[12px]">
            <PlaceholderB
              label="대표자 이름"
              mode="input"
              placeholder="실명을 입력해 주세요"
              required
              value={businessOwnerName}
              onChange={(e) => setBusinessOwnerName(e.target.value)}
              autoComplete="name"
              rightIconMode="clear"
            />

            <PlaceholderB
              label="사업자등록번호"
              mode="input"
              required
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={12}
              value={formatBizNumber(businessNumber)}
              onChange={(e) => {
                const onlyDigits = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
                setBusinessNumber(onlyDigits);
              }}
              autoComplete="off"
              placeholder="예: 123-45-67890"
              rightIconMode="clear"
            />
          </div>

          <CategoryBottomSheet
            mainCategory={mainCategory}
            setMainCategory={setMainCategory}
            mainCategories={mainCategories}
            subCategory={subCategory}
            setSubCategory={setSubCategory}
            subCategories={subCategories}
            detailCategory={detailCategory}
            setDetailCategory={setDetailCategory}
            detailCategories={detailCategories}
            setCategory={setCategory}
          />
        </div>

        <div className="mt-auto text-c2 text-text-danger flex gap-[4px]">
          <img src={infoRed} alt="경고" className="w-[16px] h-[17px]" />
          <p>본인과 관련 없는 사업자를 등록하는 경우 이용 제한과 법적 제재를 받을 수 있습니다.</p>
        </div>
      </div>

      <div ref={footerRef} className="fixed bottom-0 left-0 right-0 bg-surface-default">
        <SingleButton onClick={onSubmit} disabled={loading || isSubmitDisabled}>
          {loading ? "처리 중..." : "등록하기"}
        </SingleButton>
      </div>
    </div>
  );
};

export default AdsRegistSelf7;
